import { configureStore } from '@reduxjs/toolkit';
import customerManagementReducer from './reducers/customerManagementReducer';
import authReducer from './reducers/authReducer';
import transactionManagementReducer from './reducers/transactionManagementReducer';
import locationsReducer from './reducers/locationsReducer';
import exchangeRatesReducer from './reducers/exchangeRatesReducer';
import userReducer from './reducers/userReducer';
import serviceFeesReducer from './reducers/serviceFeesReducer';
import complianceManagementReducer from './reducers/complianceManagementReducer';
import merchantManagementReducer from './reducers/merchantManagementReducer';
import rolesAndPermissionsReducer from './reducers/rolesAndPermissionsReducer';
import eventCategoryReducer from './reducers/eventCategoryReducer';
import businessReducer from './reducers/businessReducer';
import eventsReducer from './reducers/eventReducer';
import merchantReducer from './reducers/eventMerchantReducer';
import businessCategoryReducer from './reducers/businessCategoryReducer';
import businessTypeReducer from './reducers/businessTypeReducer';
import deliveryRatesReducer from './reducers/deliveryRatesReducer';
import agentReducer from './reducers/agentReducer';
import floatRequestReducer from './reducers/floatRequestReducer';
import transferReducer from './reducers/transferReducer';

export const store = configureStore({
	reducer: {
		auth: authReducer,
		customerManagement: customerManagementReducer,
		transactionManagement: transactionManagementReducer,
		locations: locationsReducer,
		exchangeRates: exchangeRatesReducer,
		users: userReducer,
		serviceFees: serviceFeesReducer,
		complianceManagement: complianceManagementReducer,
		merchantManagement: merchantManagementReducer,
		eventCategory: eventCategoryReducer,
		businessCategory: businessCategoryReducer,
		businessType: businessTypeReducer,
		deliveryRates: deliveryRatesReducer,
		agents: agentReducer,
		events: eventsReducer,
		floatRequest: floatRequestReducer,
		business: businessReducer,
		merchants: merchantReducer,
		rolesAndPermissions: rolesAndPermissionsReducer,
		transfers: transferReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
